import { styled } from '@ori-ui/mui';
export var ImageRoot = styled('img')({
  height: '100%',
  left: '50%',
  maxHeight: '100%',
  maxWidth: '100%',
  objectFit: 'contain',
  overflow: 'hidden',
  position: 'absolute',
  top: '50%',
  transition: 'filter 400ms, opacity 400ms, transform 500ms !important',
  width: '100%',
  transform: 'translate(-50%, -50%) scale(1)'
});
//# sourceMappingURL=styles.js.map